export default __webpack_public_path__ + "static/media/placeholder-3.c6f00b71.png";